export default{
  data() {
    return {
      // style: '',
      rotateing: false,
      angle: 0, // 旋转的角度
      stopAt: 0, // 停止的角度
      acceleration: 0.5, // 加速的加速度0.5
      r_acceleration: 0.1, // 减速的加速度0.1
      firstTimes: 48 // 48次
    }
  },
  computed: {
    style() {
      return 'transform: rotate3d(0,0,1,' + this.angle + 'deg)'
    }
  },
  methods: {
    start() {
      // 重置数据
      this.stopAt = 0
      this.rotateing = true
      // 计算
      var self = this
      var speed = 0
      var acceleration = self.acceleration // 加速的加速度
      var racceleration = self.r_acceleration // 减速的加速度
      var firstTimes = self.firstTimes //  执行48次 加速到highSpeed
      var highSpeed = firstTimes * acceleration // 最高速度
      var oneAngel = self.angle + firstTimes * (firstTimes - 1) / 2 * acceleration + highSpeed // 第一阶段的旋转度数
      var secondTimes = 0 // 速度为highSpeed 继续执行10次
      var twoAngel, three, add, twoAngelEnd, threeAngel
      var prepared = false
      const prepare = () => {
        twoAngel = oneAngel + secondTimes * firstTimes * acceleration // 第二阶段的旋转度数
        three = highSpeed / racceleration // 执行three次 速度从highSpeed减速到0
        add = 360 - (twoAngel + three * (three - 1) / 2 * racceleration) % 360 + self.stopAt // 使最后刚好转到起点位置
        twoAngelEnd = twoAngel + add // 第三阶段开始
        threeAngel = twoAngelEnd + three * (three - 1) / 2 * racceleration // 最后的旋转度数
      }
      function cicle () {
        if (!self.rotateing && !prepared) {
          // secondTimes += 10
          prepare()
          prepared = true
        }
        if (self.angle < oneAngel) {
          speed += acceleration
          self.angle += speed
        } else if (self.angle >= oneAngel && (self.rotateing || self.angle < twoAngel)) {
          self.angle += speed
          if (self.rotateing) {
            secondTimes++
          }
        } else if (self.angle.toFixed(2) === twoAngel.toFixed(2)) {
          self.angle += add
        } else if (self.angle > twoAngel && self.angle <= threeAngel) {
          speed -= racceleration
          if (speed <= 0) {
            speed = 0
            self.angle = threeAngel % 360
            if (self.cb) {
              // 回调停止
              self.cb()
            }
            return false
          }
          self.angle += speed
        }
        requestAnimationFrame(cicle)
      }
      cicle()
    },
    stop(deg, cb) {
      this.rotateing = false
      this.stopAt = deg
      this.cb = cb
    },
    reset() {
      // 重置到起点
      this.angle = 0
    }
  }
}


// WEBPACK FOOTER //
// ./src/components/base/activity/rotate/base.js